import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Order } from '../../../../models/order.model';
import { WidgetOrdersDisplayComponent } from '../../../../shared/components/widget-displays/widget-orders-display/widget-orders-display.component';
import {
  getActiveOrders,
  getOrdersLoaded,
  getOrdersLoading,
  getTotalActiveLocations,
  LoadOrders,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-orders',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetOrdersDisplayComponent],
  template: `
    <app-widget-orders-display
      [hyperlink]="'/orders'"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [orderCount]="totalOpenOrders()?.length"
      [locationCount]="totalActiveLocations()"
    ></app-widget-orders-display>
  `,
})
export class WidgetOrdersComponent implements OnInit, OnDestroy {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  private readonly destroy$ = new Subject<void>();

  readonly totalActiveLocations = toSignal<number>(
    this.store.select(getTotalActiveLocations),
  );

  readonly totalOpenOrders = toSignal<Order[]>(
    this.store.select(getActiveOrders),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getOrdersLoading));

  ngOnInit(): void {
    this.store
      .select(getOrdersLoaded)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new LoadOrders());
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
